import { render, staticRenderFns } from "./NewsHistory.vue?vue&type=template&id=ad2e08ee&scoped=true"
import script from "./NewsHistory.vue?vue&type=script&lang=js"
export * from "./NewsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2e08ee",
  null
  
)

export default component.exports